// File: src/components/ImageSection.jsx
import React, { useEffect, useState } from "react";
import "../styles/components/ImageSection.css";
import HealthcareImage1 from "../images/healthcare_interaction_1.png";
import HealthcareImage2 from "../images/healthcare_interaction_2.png";
import HealthcareImage3 from "../images/healthcare_interaction_3.jpg";
import HealthcareImageCroped1 from "../images/healthcare_interaction_1_croped.png";
import HealthcareImageCroped2 from "../images/healthcare_interaction_2_croped.png";
import HealthcareImageCroped3 from "../images/healthcare_interaction_3_croped.jpg";
import BookAppointmentForm from "./BookAppointmentForm";
import ApplyModal from "./ApplyModal";
import { FaTimes } from "react-icons/fa";

/* Why: single source of truth for roles shown in the careers modal. */
const ROLE_OPTIONS = [
  "Business Development",
  "Biller",
  "IT Support",
  "Medical Assistants",
  "Front Office",
  "Nurse Practitioners",
  "Customer Service Representative",
  "Office Manager",
  "Nurse Practitioner",
  "Medical Biller",
  "Medical Technician",
];

const ImageSection = ({ title, onBookConsultationClick, forCarrersPage }) => {
  const images = [HealthcareImage1, HealthcareImage2, HealthcareImage3];
  const croppedImages = [HealthcareImageCroped1, HealthcareImageCroped2, HealthcareImageCroped3];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [openApply, setOpenApply] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 769 : true
  );

  // Resize listener for responsive hero image.
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Slideshow: PAUSE when any modal/form is open to prevent input focus jumps.
  useEffect(() => {
    const shouldRun = !openApply && !showForm;
    if (!shouldRun) return; // pause
    const id = setInterval(() => {
      setCurrentImageIndex((i) => (i === images.length - 1 ? 0 : i + 1));
    }, 3000);
    return () => clearInterval(id);
  }, [images.length, openApply, showForm]);

  const toggleForm = () => setShowForm((s) => !s);

  const handleButtonClick = () => {
    if (forCarrersPage) {
      setOpenApply(true); // open careers Apply modal (with Role dropdown)
    } else if (onBookConsultationClick) {
      onBookConsultationClick();
    } else {
      toggleForm();
    }
  };

  const handleApplySubmit = (payload) => {
    // Hook your NodeMailer endpoint here later.
    console.log("Career registration payload:", payload);
    alert("Application submitted! We will contact you shortly.");
    setOpenApply(false);
  };

  // Minor: prevent background scroll when a modal is open.
  useEffect(() => {
    const hasOverlay = openApply || showForm;
    if (hasOverlay) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [openApply, showForm]);

  const imgSrc = isMobile ? images[currentImageIndex] : croppedImages[currentImageIndex];

  return (
    <div className="image-section">
      <img
        src={imgSrc}
        alt="Healthcare Services"
        className="img-fluid"
        style={{ objectFit: "cover" }}
        aria-hidden={openApply || showForm ? "true" : "false"} // why: reduce AT noise when overlay open
      />

      <div className="image-overlay" aria-hidden={openApply || showForm}>
        <h1>{title}</h1>
        <div className="buttons">
          <button className="btn btn-primary" onClick={handleButtonClick}>
            {forCarrersPage ? "Apply For Registration" : "Let's Book a Consultation"}
          </button>
        </div>
      </div>

      {/* Consultation form (non-careers) */}
      {showForm && (
        <div className="form-overlay">
          <div className="form-container">
            <button className="close-btn" onClick={handleButtonClick}>
              <FaTimes color="white" />
            </button>
            <BookAppointmentForm messageRows={1} />
          </div>
        </div>
      )}

      {/* Careers Apply Modal (with roles dropdown only for this button) */}
      <ApplyModal
        open={openApply}
        allowRoleSelect={true}
        roleOptions={ROLE_OPTIONS}
        onClose={() => setOpenApply(false)}
        onSubmit={handleApplySubmit}
      />
    </div>
  );
};

export default ImageSection;
